import { connect } from 'react-redux';
import { showReportModal } from '../../../../Moderation/redux/actions';
import { pushNftLinkPopup } from '../../../../Modals/redux/actionCreators';
import { getIsCurrentUserAuthorOf } from '../../../../redux/deviations/selectors';
import { shareDeviationToPost } from '../../../../redux/deviations/actionCreators';
const mapStateToProps = (state, ownProps)=>({
        isOwner: getIsCurrentUserAuthorOf(state, ownProps.deviation)
    });
const mapDispatchToProps = {
    showReportModal,
    shareDeviationToPost,
    showNftLinkPopup: pushNftLinkPopup
};
export default connect(mapStateToProps, mapDispatchToProps);
